/* Gwennie Gloss Garage — selection, waitlist, menu, drops, and event tracking */
(function () {
  if (window.__gwennie) return;
  window.__gwennie = true;

  var STORE_KEY = 'gw_pick';
  var EVENTS_KEY = 'gw_events';
  var MAX_EVENTS = 500;

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function referrerHost() {
    try { return document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) { return ''; }
  }

  function track(name, data) {
    var payload = Object.assign({
      event: name,
      ts: new Date().toISOString(),
      path: location.pathname,
      referrer: referrerHost()
    }, data || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try {
      document.dispatchEvent(new CustomEvent('gwennie:' + name, { detail: payload }));
    } catch (e) {}

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('gwennie_' + name, payload);
      }
    } catch (e) {}

    var events = read(EVENTS_KEY) || [];
    events.push(payload);
    if (events.length > MAX_EVENTS) events = events.slice(events.length - MAX_EVENTS);
    write(EVENTS_KEY, events);
  }
  window.gwTrack = track;

  var pick = read(STORE_KEY) || { mood: '', color: '' };
  var dropEl = document.querySelector('[data-gw-drop-page]');
  var dropName = dropEl ? dropEl.getAttribute('data-gw-drop-page') : '';
  var dropWorld = dropEl ? (dropEl.getAttribute('data-gw-world') || 'gwennie') : '';
  var PIECE_KEY = 'gw_piece_' + dropName;
  var piece = dropName ? (read(PIECE_KEY) || '') : '';

  function tagValue() {
    var tags = ['gwennie-list'];
    if (dropName) {
      tags.push('world:' + dropWorld);
      tags.push('collection:' + dropName);
      if (piece) tags.push('piece:' + piece.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
    } else {
      if (pick.mood) tags.push('mood:' + pick.mood);
      if (pick.color) tags.push('color:' + pick.color);
    }
    var ref = referrerHost();
    if (ref) tags.push('ref:' + ref.replace(/[^a-z0-9.-]/gi, ''));
    return tags.join(', ');
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render() {
    document.querySelectorAll('[data-gw-mood]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.getAttribute('data-gw-mood') === pick.mood ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gw-color]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.getAttribute('data-gw-color') === pick.color ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gw-piece]').forEach(function (el) {
      el.setAttribute('aria-pressed', el.getAttribute('data-gw-piece') === piece ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gw-tags]').forEach(function (el) { el.value = tagValue(); });
    document.querySelectorAll('[data-gw-summary]').forEach(function (el) {
      if (dropName) {
        el.innerHTML = piece ? 'Your pick: <strong>' + esc(piece) + '</strong>.' : 'Pick the piece you want most. Optional.';
      } else if (pick.mood && pick.color) {
        el.innerHTML = 'Your pick: <strong>' + esc(pick.mood) + '</strong> in <strong>' + esc(pick.color) + '</strong>.';
      } else if (pick.mood) {
        el.innerHTML = 'Your pick: <strong>' + esc(pick.mood) + '</strong>. Choose a color too.';
      } else if (pick.color) {
        el.innerHTML = 'Your color: <strong>' + esc(pick.color) + '</strong>. Choose a mood too.';
      } else {
        el.textContent = 'Pick a mood and a color. Both are optional.';
      }
    });
    document.querySelectorAll('[data-gw-success-pick]').forEach(function (el) {
      if (dropName) {
        if (piece) el.textContent = piece + ' is saved with your email.';
      } else if (pick.mood || pick.color) {
        el.textContent = [pick.mood, pick.color].filter(Boolean).join(' in ') + ' is saved with your email.';
      }
    });
  }

  function setMood(mood, source) {
    pick.mood = (pick.mood === mood && source !== 'form') ? '' : mood;
    write(STORE_KEY, pick);
    render();
    if (pick.mood) track('mood_selected', { mood: pick.mood, color: pick.color, source: source });
  }
  function setColor(color, source) {
    pick.color = (pick.color === color && source !== 'form') ? '' : color;
    write(STORE_KEY, pick);
    render();
    if (pick.color) track('color_selected', { color: pick.color, mood: pick.mood, source: source });
  }
  function setPiece(name, source) {
    piece = (piece === name && source !== 'form') ? '' : name;
    write(PIECE_KEY, piece);
    render();
    if (piece) track('piece_selected', { world: dropWorld, collection: dropName, piece: piece, source: source });
  }

  document.addEventListener('click', function (e) {
    var pieceEl = e.target.closest('[data-gw-piece]');
    if (pieceEl) {
      setPiece(pieceEl.getAttribute('data-gw-piece'), pieceEl.getAttribute('data-gw-source') || 'tile');
      return;
    }
    var dropLink = e.target.closest('[data-gw-drop-link]');
    if (dropLink) track('drop_clicked', { collection: dropLink.getAttribute('data-gw-drop-link'), world: dropLink.getAttribute('data-gw-drop-world') || 'gwennie' });
    var moodEl = e.target.closest('[data-gw-mood]');
    if (moodEl) {
      setMood(moodEl.getAttribute('data-gw-mood'), moodEl.getAttribute('data-gw-source') || 'tile');
      return;
    }
    var colorEl = e.target.closest('[data-gw-color]');
    if (colorEl) {
      setColor(colorEl.getAttribute('data-gw-color'), colorEl.getAttribute('data-gw-source') || 'tile');
    }
  });

  var started = false;
  document.addEventListener('focusin', function (e) {
    if (started) return;
    if (e.target.closest && e.target.closest('[data-gw-waitlist]')) {
      started = true;
      track('waitlist_started', { mood: pick.mood, color: pick.color, world: dropWorld, collection: dropName, piece: piece });
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-gw-waitlist]');
    if (!form) return;
    document.querySelectorAll('[data-gw-tags]').forEach(function (el) { el.value = tagValue(); });
    track('waitlist_submitted', { mood: pick.mood, color: pick.color, world: dropWorld, collection: dropName, piece: piece });
  });

  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DETAILS' && d.open && d.closest('[data-gw-faq]')) {
      var q = d.querySelector('summary');
      track('faq_opened', { question: q ? q.textContent.trim() : '' });
    }
  }, true);

  function watchHow() {
    var how = document.querySelector('[data-gw-how]');
    if (!how || !('IntersectionObserver' in window)) return;
    var seen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen) {
          seen = true;
          track('how_it_works_viewed', {});
          io.disconnect();
        }
      });
    }, { threshold: 0.5 });
    io.observe(how);
  }

  function afterPost() {
    var params = new URLSearchParams(location.search);
    if (params.get('customer_posted') === 'true') {
      var target = document.querySelector('[data-gw-waitlist-section]');
      if (target) {
        setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
      }
    }
  }

  function initNav() {
    var wrap = document.querySelector('[data-gw-navwrap]');
    var nav = wrap && wrap.querySelector('[data-gw-nav]');
    if (!nav) return;
    var toggle = nav.querySelector('[data-gw-nav-toggle]');
    var threshold = 0;
    function measure() { threshold = wrap.getBoundingClientRect().top + window.scrollY + 30; }
    function onScroll() {
      var fixed = window.scrollY > threshold;
      if (fixed !== nav.classList.contains('is-fixed')) {
        nav.classList.toggle('is-fixed', fixed);
        if (!fixed) nav.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); });
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) track('menu_opened', {});
      });
    }
    nav.addEventListener('click', function (e) {
      var link = e.target.closest('.gw-navlink');
      if (!link) return;
      nav.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      track('menu_link_clicked', { label: link.textContent.trim() });
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function init() {
    render();
    watchHow();
    afterPost();
    initNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Meta paid → Original PDP */
(function(){
  try {
    if (window.__gwMetaPdpRedirect) return;
    window.__gwMetaPdpRedirect = true;
    var path = location.pathname.replace(/\/$/, '') || '/';
    if (path !== '/' && path !== '') return;
    var q = new URLSearchParams(location.search);
    var src = (q.get('utm_source') || '').toLowerCase();
    var camp = (q.get('utm_campaign') || '').toLowerCase();
    var paid = src === 'meta' || src === 'facebook' || src === 'ig' || src === 'instagram'
      || camp.indexOf('ggg_sales') === 0 || camp.indexOf('ggg_') === 0;
    if (!paid) return;
    var dest = '/products/gwennie-original-gloss-garage' + location.search + location.hash;
    location.replace(dest);
  } catch (e) {}
})();

/* FB lander color collapse */
(function(){
  try {
    var q = new URLSearchParams(location.search);
    var src = (q.get('utm_source') || '').toLowerCase();
    var camp = (q.get('utm_campaign') || '').toLowerCase();
    var paid = src === 'meta' || src === 'facebook' || src === 'ig' || src === 'instagram'
      || camp.indexOf('ggg_sales') === 0 || camp.indexOf('ggg_') === 0;
    if (!paid) return;
    document.documentElement.classList.add('gw-meta-lander');
    if (document.body) document.body.classList.add('gw-meta-lander');
    function collapse(){
      if (!document.body) return;
      document.body.classList.add('gw-meta-lander');
      document.querySelectorAll('input[type="radio"]').forEach(function(inp){
        var v = (inp.value || '').toLowerCase();
        if (v === 'cream' || v === 'lilac' || v === 'sage') {
          var lab = inp.closest('label') || inp.parentElement;
          if (lab) lab.classList.add('gw-color-extra');
        }
        if (v === 'blush') {
          try { inp.checked = true; inp.dispatchEvent(new Event('change', {bubbles:true})); } catch(e){}
        }
      });
      if (document.querySelector('.gw-more-colors')) return;
      var extra = document.querySelector('.gw-color-extra');
      if (!extra || !extra.parentElement) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gw-more-colors';
      btn.textContent = 'More colors';
      btn.addEventListener('click', function(){
        document.querySelectorAll('.gw-color-extra').forEach(function(el){ el.classList.remove('gw-color-extra'); });
        btn.remove();
      });
      extra.parentElement.appendChild(btn);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapse);
    else collapse();
    setTimeout(collapse, 400);
    setTimeout(collapse, 1200);
  } catch (e) {}
})();

/* FB first-paint pill */
(function(){
  try {
    var path = location.pathname.replace(/\/$/, '');
    if (path.indexOf('/products/gwennie-original') === -1) return;
    function paint(){
      if (document.querySelector('.gw-first-paint')) return;
      var host = document.querySelector('product-price, .price, [data-product-price], .product-details .price') ||
                 document.querySelector('variant-selects, .variant-picker, [name="id"]');
      if (!host) return;
      var el = document.createElement('div');
      el.className = 'gw-first-paint';
      el.textContent = '$12.99 · free US ship · gloss not included (park hers on top)';
      var parent = host.closest('.product-details') || host.parentElement;
      if (!parent) return;
      if (host.nextSibling) parent.insertBefore(el, host.nextSibling);
      else parent.appendChild(el);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
    else paint();
    setTimeout(paint, 300);
    setTimeout(paint, 900);
  } catch (e) {}
})();
/* paint-bust:1789957916 */
